<template>
    <div style="pointer-events: auto;z-index: 1000;color:#fff;">
        <x-dialog-comp :title="titleName" @on-close="$emit('on-close')">
            <div class="flex" style="height: 750px">
                <div v-if="this.compData.bindingType == '/other/qljcxx/list?pageNum=1&pageSize=9999'">
                    <div class="flex" style="width: 400px;margin-left: 10px;">
                        <div class="text-left">
                            <img src="@/assets/common/基础信息.png" style="width: 250px">
                        </div>
                        <div class="text-left margin-top">
                            <div class="flex align-center dandukuang">
                                <div class="x-xiaoDian"></div>
                                <div class="x-kuandu">名称 :</div>
                                <div class="margin-left neirongkuandu">{{ xiangqinglist.name || '--' }}</div>
                            </div>
                            <div class="flex align-center dandukuang">
                                <div class="x-xiaoDian"></div>
                                <div class="x-kuandu">点位 :</div>
                                <div class="margin-left neirongkuandu">{{ xiangqinglist.location || '--' }}</div>
                            </div>
                            <div class="flex align-center dandukuang">
                                <div class="x-xiaoDian"></div>
                                <div class="x-kuandu">桥长 :</div>
                                <div class="margin-left neirongkuandu">{{ xiangqinglist.bridgeLength || '--' }}
                                </div>
                            </div>
                            <div class="flex align-center dandukuang">
                                <div class="x-xiaoDian"></div>
                                <div class="x-kuandu">桥宽 :</div>
                                <div class="margin-left neirongkuandu">{{ xiangqinglist.bridgeWidth || '--' }}</div>
                            </div>
                            <div class="flex align-center dandukuang">
                                <div class="x-xiaoDian"></div>
                                <div class="x-kuandu">管理人员 :</div>
                                <div class="margin-left neirongkuandu">{{ xiangqinglist.manager || '--' }}</div>
                            </div>
                            <div class="flex align-center dandukuang">
                                <div class="x-xiaoDian"></div>
                                <div class="x-kuandu">联系方式 :</div>
                                <div class="margin-left neirongkuandu">{{ xiangqinglist.contact || '--' }}</div>
                            </div>
                            <div class="flex align-center dandukuang">
                                <div class="x-xiaoDian"></div>
                                <div class="x-kuandu">工程档案 :</div>
                                <div class="margin-left neirongkuandu" style="color: #91ecff;cursor: pointer;"
                                    v-if="showPhotoLink(xiangqinglist.engineeringArchives)"
                                    @click="handleClickchakanpdf(xiangqinglist.engineeringArchives, '')">查看文件</div>
                                <div class="margin-left neirongkuandu" style="width:10%;" v-else>暂无文件</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-sub text-left">
                    <div>
                        <div style="margin-top: 40px;">
                            <div v-if="xiangqinglist.photo == '' || xiangqinglist.photo == null"
                                style="width: 650px;height: 650px;border-radius: 10px; border: 1px solid white;">
                                <span class="zanwushujusptwo">暂无照片</span>
                            </div>
                            <div v-else class="youcelunbo">
                                <el-carousel height="650px" width="650px">
                                    <el-carousel-item v-for="imgurl in xiugaitupian(xiangqinglist.photo)" :key="imgurl">
                                        <img :src="imgurl" style="width: 650px;height: 650px;border-radius: 10px" />
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </x-dialog-comp>
        <chakanPDF ref="dialog" v-if="chakanpdf" :chakanpdfId="chakanpdfId" :chakanpdfName="chakanpdfName"
            @on-point="chakanpdf = false">
        </chakanPDF>
        <pdflist ref="dialog" v-if="pdflb" :pdflist="chakanpdfId" :pdfName="chakanpdfName" @on-point="pdflb = false">
        </pdflist>
    </div>
</template>

<script>
import chakanPDF from "@/views/ShuiKuZongHe/zonghetaishi/zujian/chakanPDF";
import pdflist from "@/views/ShuiKuZongHe/zonghetaishi/zujian/pdflist";
import {
    listQljcxx,
    getQljcxx
} from "@/api/other/qljcxx";
import {
    listDistrict,
    optionSelect
} from '@/api/system/district';
import {
    getDictData
} from "@/utils/dict";
import {
    listRivers
} from "@/api/water/rivers";
import {
    listLake
} from "@/api/weather/lake";
import {
    listReservoir
} from "@/api/water/reservoir";
import {
    listIrrigatedArea
} from "@/api/water/irrigatedArea";
import {
    listPumpDevice
} from "@/api/water/pumpDevice";
import {
    listSluice
} from "@/api/water/sluice";
import {
    listChannel
} from "@/api/water/channel";
import {
    listPumpHouse
} from "@/api/water/pumpHouse";

import XDialogComp from "@/components/x-dialog-comp";
import XTitleBtn from "@/components/x-title-btn";

export default {
    name: "x-device-ShangQing",
    props: ['compData', 'titleName'],
    components: {
        XTitleBtn,
        XDialogComp,
        chakanPDF,
        pdflist,
    },
    data: () => {
        return {
            chakanpdf: false,
            chakanpdfId: '',
            chakanpdfName: '',
            pdflb: false,
            optionsLocationCode: [],
            optionSelect: [],
            administrationIdProps: {
                value: 'id',
                label: 'name',
                children: 'children',
                checkStrictly: true,
                expandTrigger: 'hover',
                emitPath: false
            },
            optionsRiver: [{
                label: '河流',
                value: 1,
            }, {
                label: '湖泊',
                value: 2
            }, {
                label: '水库',
                value: 3
            }, {
                label: '渠道',
                value: 4
            }, {
                label: '灌区',
                value: 5
            }, {
                label: '水闸',
                value: 6
            }, {
                label: '泵房',
                value: 7
            }],
            xiangqinglist: {},
            bridge_type: [],
            structure_type: [],
            road_level: [],
            hh_ab: [],
            fanhuinname: "",
            heliuMap: new Map()
        }
    },
    created() {
    },
    mounted() {
        console.log('%c [ 进入交通桥详情页 ]-254', 'font-size:13px; background:pink; color:#bf2c9f;', this.compData)
        if (this.compData.bindingType == '/other/qljcxx/list?pageNum=1&pageSize=9999') {
            this.getjichujiazai()
            console.log("打开交通桥弹窗:", this.compData.bindingId)
            this.getjiaotongqiaolist(this.compData.bindingId)
        }
    },
    beforeDestroy() { },
    methods: {

        showPhotoLink(data) {
            return data !== null && data !== '';
        },
        handleClickchakanpdf(data, name) {
            console.log("当前被点击的id" + data)
            this.chakanpdfId = data;
            this.chakanpdfName = String(name);
            if (this.chakanpdfName == "null") {
                this.chakanpdfName = ""
            }
            const regex = /\.pdf/g;
            const count = (data.match(regex) || []).length;
            console.log(count)
            if (count == 1) {
                console.log("1111")
                this.chakanpdf = true;
            } else {
                this.pdflb = true;
            }
        },
        getjichujiazai() {
            this.getxingzhengquhua()
            getDictData("bridge_type").then((val) => {
                this.bridge_type = val;
            });
            getDictData("structure_type").then((val) => {
                this.structure_type = val;
            });
            getDictData("road_level").then((val) => {
                this.road_level = val;
            });
            getDictData("hh_ab").then((val) => {
                this.hh_ab = val;
            });
        },
        onCascaderChange(id) {
            console.log(id)
            console.log(this.xiangqinglist.locationType)
            switch (Number(this.xiangqinglist.locationType)) {
                case 1:
                    listRivers({
                        pageNum: 1,
                        pageSize: 99999
                    }).then(response => {
                        this.optionsLocationCode = response.rows;
                        this.heliuMap.clear();
                        for (var i = 0; i < this.optionsLocationCode.length; i++) {
                            this.heliuMap.set(this.optionsLocationCode[i]["id"], this.optionsLocationCode[i]["name"])
                        }
                        this.fanhuiname(id)
                    });
                    break;
                case 2:
                    listLake({
                        pageNum: 1,
                        pageSize: 99999
                    }).then(response => {
                        this.optionsLocationCode = response.rows;
                        this.heliuMap.clear();
                        for (var i = 0; i < this.optionsLocationCode.length; i++) {
                            this.heliuMap.set(this.optionsLocationCode[i]["id"], this.optionsLocationCode[i]["name"])
                        }
                        this.fanhuiname(id)
                    });
                    break;
                case 3:
                    listReservoir({
                        pageNum: 1,
                        pageSize: 99999
                    }).then(response => {
                        this.optionsLocationCode = response.rows;
                        this.heliuMap.clear();
                        for (var i = 0; i < this.optionsLocationCode.length; i++) {
                            this.heliuMap.set(this.optionsLocationCode[i]["id"], this.optionsLocationCode[i]["name"])
                        }
                        this.fanhuiname(id)
                    });
                    break;
                case 4:
                    listChannel({
                        pageNum: 1,
                        pageSize: 99999
                    }).then(response => {
                        this.optionsLocationCode = response.rows;
                        this.heliuMap.clear();
                        for (var i = 0; i < this.optionsLocationCode.length; i++) {
                            this.heliuMap.set(this.optionsLocationCode[i]["id"], this.optionsLocationCode[i]["name"])
                        }
                        this.fanhuiname(id)
                    });
                    break;
                case 5:
                    listIrrigatedArea({
                        pageSize: 99999,
                        pageNum: 1
                    }).then(response => {
                        this.optionsLocationCode = response.rows;
                        this.heliuMap.clear();
                        for (var i = 0; i < this.optionsLocationCode.length; i++) {
                            this.heliuMap.set(this.optionsLocationCode[i]["id"], this.optionsLocationCode[i]["name"])
                        }
                        this.fanhuiname(id)
                    });
                    break;
                case 6:
                    listSluice({
                        pageSize: 99999,
                        pageNum: 1
                    }).then(response => {
                        this.optionsLocationCode = response.rows;
                        this.heliuMap.clear();
                        for (var i = 0; i < this.optionsLocationCode.length; i++) {
                            this.heliuMap.set(this.optionsLocationCode[i]["id"], this.optionsLocationCode[i]["name"])
                        }
                        this.fanhuiname(id)
                    });
                    break;
                case 7:
                    listPumpHouse({
                        pageSize: 99999,
                        pageNum: 1
                    }).then(response => {
                        this.optionsLocationCode = response.rows;
                        this.heliuMap.clear();
                        for (var i = 0; i < this.optionsLocationCode.length; i++) {
                            this.heliuMap.set(this.optionsLocationCode[i]["id"], this.optionsLocationCode[i]["name"])
                        }
                        this.fanhuiname(id)
                    });
                    break;
                default:
                    break;
            }
        },
        fanhuiname(id) {
            id = Number(id)
            console.log(id)
            for (let i = 0; i < this.optionsLocationCode.length; i++) {
                console.log(this.optionsLocationCode[i].id, id)
                if (this.optionsLocationCode[i].id == id) {
                    console.log("+++++++++")
                    this.fanhuinname = this.optionsLocationCode[i].name
                }
            }
        },
        getlocationTypeName(locationType) {
            if (locationType != undefined) {
                return this.optionsRiver.find(option => option.value + '' == locationType)?.label;
            }
        },
        xiugaitupian(url) {
            let zhuanhuanhou = []
            if (url) {
                zhuanhuanhou = url.split(',').map(url => url.trim());
            }
            return zhuanhuanhou
        },
        getjiaotongqiaolist(id) {
            getQljcxx(id).then(response => {
                this.xiangqinglist = response.data;
                if (this.xiangqinglist.locationName != null && this.xiangqinglist.locationName != '') {
                    console.log("this.xiangqinglist.locationName")
                    this.onCascaderChange(this.xiangqinglist.locationName)
                }
            });
        },
        getxingzhengquhua() {
            optionSelect({
                pageNum: 1,
                pageSize: 9999,
            }).then(response => {
                this.optionSelect = response.data;
            });
        },
        getxingzhengquhuaName(codeid) {
            return this.searchByCodeId(this.optionSelect, codeid) || '--';
        },
        searchByCodeId(options, codeid) {
            for (const option of options) {
                if (option.id == codeid) return option.name;
                const childResult = option.children && option.children.length > 0 ?
                    this.searchByCodeId(option.children, codeid) :
                    null;
                if (childResult) return childResult;
            }
            return null;
        },
        closeClick() {
            this.$emit('on-close')
        },
    }
}
</script>

<style scoped>
.x-tc-page-bg {
    background: url("~@/assets/common/tanChuang.png") no-repeat;
    background-size: 100% 100%;
    width: 1132px;
    height: 763px;
    position: fixed;
    top: 100px;
    left: 400px;
    z-index: 99999;
    margin-left: 55px;
}

.x-tc-page-twobg {
    background: url("~@/assets/common/tanChuang.png") no-repeat;
    background-size: 100% 100%;
    width: 1132px;
    height: 763px;
    position: fixed;
    top: 100px;
    left: 400px;
    z-index: 99999;
    margin-left: 55px;
}

.x-tc-title {
    font-size: 22px;
    position: absolute;
    left: 80px;
    top: 15px;
    color: white;
    letter-spacing: 5px;
}

.x-close {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 30px;
    cursor: pointer;
}

.x-tc-cnt {
    height: 640px;
    width: 1050px;
    overflow: auto;
}

.x-card {
    width: 230px;
    height: 270px;
    margin-right: 33px;
    float: left;
}

.x-card:nth-child(4n) {
    margin-right: 0px;
}

.x-card-cnt {
    width: 250px;
    height: 230px;
}

.x-sm-title-bg {
    background: url("~@/assets/ZhiNengXiTong/title.png") no-repeat;
    background-size: 100% 100%;
    width: 220px;
    height: 35px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    font-family: douyuFont-2;
    font-size: 14px;
}

.x-table-box {
    height: 680px;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 14px
}

.x-table-title-list-bg {
    width: 98%;
    margin-left: 1%;
    text-align: center;
    line-height: 40px;
    height: 40px;
}

.x-table-title-list-bg:nth-child(2n) {
    background: #ffffff10;
}

.x-table-title-list-bg:hover {
    background: #ffffff26;
}

.zanwushujusptwo {
    color: #218fce;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    text-align: center;
}
</style>
<style>
.youcelunbo .el-carousel__container {
    position: relative;
    width: 650px !important;
}
</style>
<style scoped>
.neirongkuandu {
    width: 251px;
}

.dialog-buttonstwo {
    text-align: right;
    float: right;
    height: 10px;
}

.xianshishou {
    cursor: pointer !important;
}

.password-error {
    color: red;
    margin-top: 10px;
}

.dialog-buttons {
    text-align: right;
    margin-top: 20px;
}

.el-input .el-input__icon {
    cursor: pointer;
}

.x-info-bg {
    width: 259px;
    height: 82px;
    background: url("~@/assets/YongZhenShuiKu/组 1429.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
}

.x-info-title {
    min-width: 186px;
    height: 25px;
    font-size: 16px;
    font-style: italic;
    text-align: left;
    color: #D1D6DF;
    line-height: 32px;
    font-weight: bolder;
    background: linear-gradient(0deg, #ACDDFF 0%, #FFFFFF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.x-xiaoDian {
    width: 31px;
    height: 31px;
    background: url("~@/assets/YongZhenShuiKu/小点.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: flex-start;
    margin-top: -5px;
}

.x-kuandu {
    width: 95px;
    text-align-last: justify;
}

.dandukuang {
    align-items: flex-start;
}
</style>